import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Consultancy from "./pages/Consultancy";
import SoftwareDevelopment from "./pages/SoftwareDevelopment";
import Testing from "./pages/Testing";
import Training from "./pages/Training";
import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import Blog from "./pages/Blog";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/consultancy" element={<Consultancy />} />
        <Route path="/software-development" element={<SoftwareDevelopment />} />
        <Route path="/testing" element={<Testing />} />
        <Route path="/training" element={<Training />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/blog" element={<Blog />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;